import { Controller } from "@hotwired/stimulus"

// Warns users when leaving a page with unsaved form changes
// Usage: Add data-controller="unsaved-changes" to the form element
export default class extends Controller {
  // { type, default } shorthand throws on this app's Stimulus version and aborts controller loading site-wide -- bare type + manual fallback instead
  static values = {
    message: String
  }

  connect() {
    this.isDirty = false
    this.isSubmitting = false

    // Track all form input changes
    this.element.addEventListener("input", this.markDirty)
    this.element.addEventListener("change", this.markDirty)

    // Don't warn when form is being submitted
    this.element.addEventListener("submit", this.handleSubmit)

    // Warn before leaving page
    window.addEventListener("beforeunload", this.handleBeforeUnload)

    console.log("UnsavedChangesController connected")

    // Debug: Check form enctype for file uploads
    const fileInputs = this.element.querySelectorAll('input[type="file"]')
    if (fileInputs.length > 0) {
      console.log('📋 Form has file inputs, enctype:', this.element.enctype)
      if (this.element.enctype !== 'multipart/form-data') {
        console.warn('⚠️ Form has file inputs but enctype is NOT multipart/form-data!')
      }
    }
  }

  disconnect() {
    this.element.removeEventListener("input", this.markDirty)
    this.element.removeEventListener("change", this.markDirty)
    this.element.removeEventListener("submit", this.handleSubmit)
    window.removeEventListener("beforeunload", this.handleBeforeUnload)
  }

  markDirty = () => {
    this.isDirty = true
  }

  handleSubmit = (event) => {
    this.isSubmitting = true

    // Debug logging for file uploads
    const form = this.element
    console.log('📤 Form submitting:', form.id || form.action)
    console.log('📤 Form enctype:', form.enctype)

    // Check all file inputs
    const fileInputs = form.querySelectorAll('input[type="file"]')
    fileInputs.forEach((input, index) => {
      console.log(`📤 File input ${index} (${input.name}):`, {
        hasFiles: input.files.length > 0,
        fileCount: input.files.length,
        files: Array.from(input.files).map(f => ({ name: f.name, size: f.size, type: f.type }))
      })
    })
  }

  handleBeforeUnload = (event) => {
    if (this.isDirty && !this.isSubmitting) {
      event.preventDefault()
      var message = this.hasMessageValue ? this.messageValue : "You have unsaved changes. Are you sure you want to leave this page?"
      // Modern browsers ignore custom messages but still show a generic prompt
      event.returnValue = message
      return message
    }
  }
}
